type JsDataType = 'Boolean' | 'Number' | 'String' | 'BigInt' | 'Object' | 'Array' | 'Function' | 'Promise' | 'Date' |  'Symbol';

export function isType (variable: unknown, type: JsDataType) {
  return Object.prototype.toString.call(variable) === '[object ' + type + ']';
}

export function isFunction (val: unknown): boolean  {
  return typeof val === 'function'
}

export function isObject (val: unknown): boolean  {
  return val !== null && typeof val === 'object' && !Array.isArray(val)
}

export function isArray (val: unknown): boolean  {
  return Array.isArray(val)
}

export function isTruthy (prop: () => unknown | boolean): boolean {
  return Boolean(isFunction(prop) ? prop() : prop)
}

export function isPromise (object: unknown | Promise<unknown>) {
  return isType(object, 'Promise')
}

export const len = (value: unknown) => {
  if (isArray(value)) return (value as []).length
  if (isObject(value)) {
    return Object.keys(value as object).length
  }
  return String(value).length
}

export const req = (value: unknown) => {
  if (isArray(value)) return !!(value as []).length
  if (value === undefined || value === null) return false
  if (value === false) return true
  // invalid date won't pass
  if (value instanceof Date) return !isNaN(value.getTime())
  if (isObject(value)) return !!len(value)
  return !!String(value).length
}

export default {
  isFunction,
  isObject,
  isTruthy,
  isPromise,
  isType,
  len,
  req
}
